import React from 'react';
import { Link } from 'react-router-dom';

function Unauthorized() {
  return (
      <div className="container">
          <h1>Unauthorized</h1>
          <p>You are not authorized to view that resource.</p><p><Link to={`/`}>Return Home</Link></p>
      </div>
  );
}

export default Unauthorized; 
